import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { from } from 'rxjs';
import { CapacitorHttp, HttpOptions } from '@capacitor/core';
import { AppConfig } from 'src/app/app.config';

@Injectable({
  providedIn: 'root'
})
export class AuthApiService {
  
  constructor(private readonly http: HttpClient) { }


  b2cTokenApi(code: string, code_verifier: string){
    const url = `${AppConfig.settings?.B2C_LOGIN_AUTHORITY}/oauth2/v2.0/token`;
    const body = new URLSearchParams();
    body.set('client_id', AppConfig.settings?.B2C_CLIENT_ID || '');
    body.set('grant_type', 'authorization_code');
    body.set('redirect_uri', AppConfig.settings?.B2C_REDIRECT_URI || '');
    body.set('scope', AppConfig.settings?.B2C_USER_TOKEN_SCOPE || '');
    body.set('code_verifier', code_verifier);
    body.set('code', code);
    return this.http.post(url, body.toString(), {
      headers: { skip: 'true', 'Content-Type': 'application/x-www-form-urlencoded' }
    });
  }

  b2cRefreshTokenApi(refresh_token: string) {
    const url = `${AppConfig.settings?.B2C_LOGIN_AUTHORITY}/oauth2/v2.0/token`;
    const body = new URLSearchParams();
    body.set('client_id', AppConfig.settings?.B2C_CLIENT_ID || '');
    body.set('grant_type', 'refresh_token');
    body.set('redirect_uri', AppConfig.settings?.B2C_REDIRECT_URI || '');
    body.set('scope', AppConfig.settings?.B2C_USER_TOKEN_SCOPE || '');
    body.set('refresh_token', refresh_token);
    return this.http.post(url, body.toString(), {
      headers: { skip: 'true', 'Content-Type': 'application/x-www-form-urlencoded' }
    });
  }

  signalRTokenApi(userId: string, data: any) {
    const options: HttpOptions = {
      url: AppConfig.settings?.SIGNALR_WRAPPER_API_BASE_URL + '/negotiate',
      headers: {
        'x-ms-client-principal-id': userId,
        'Content-Type': 'application/json',
        'skip': 'true'
      },
      data
    };
    return from(CapacitorHttp.post(options));
  }

  loginTokenApi(userId: string, data: any) {
    const url = AppConfig.settings?.CSS_FUNC_APP_PUBLIC_API_BASE_URL + '/web-negotiate';
    return  this.http.post(url, data, {headers: {'x-ms-client-principal-id': userId, skip:"true"}});
  }

  appUpdateCheckApi() {
    const url = AppConfig.settings?.CSS_FUNC_APP_PUBLIC_API_BASE_URL + '/check-mobile-app-update';
    return  this.http.get(url, {headers: {skip:"true"}});
  }

}
